export default __webpack_public_path__ + "static/0075-951ade0a5426d3ec12e5dc33af6f2655.png";